<template>
    <div class="mb-5">
        <div class="element-label">{{schema.label}}</div>
        <ckeditor :editor="editor" v-model="editorValue" @blur="blur" :config="editorConfig" />
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {

    data() {
        return {
            holdValue: null,
            editor: ClassicEditor,
            editorConfig: {
                removePlugins: [ 'Heading', 'UndoUI' ]
            }
        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object, 
    },

    computed: {
        editorValue: {
            get() {
                return this.value || ''
            },
            set(newVal) {
                this.holdValue = newVal
            }
        }

    },

    methods: {
        checkForNumber(e) {
            console.log(e)
            if(!NumberHelpers.isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault()
            }
        },

        isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1)
        },

        blur(e) {
            this.$emit('change', this.holdValue)
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// HtmlControl.vue?63de8dd6